module.exports = __webpack_public_path__ + "static/assets/fe7cfcc4ee0ded4f5732a59a630503ac.svg";